import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { SAVE_CUISINE_TYPES_MUTATION } from '../graphql/mutations'
import { transformToSaveCuisineTypesArgs } from '../graphql/transformers'
import { SAVE_CUISINE_TYPES } from '../redux/action-types'

const useSaveCuisineTypesMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.cuisineTypes.cuisineTypes,
  )

  const mutate = useCallback(
    async data => {
      await apolloService.mutate(
        SAVE_CUISINE_TYPES_MUTATION,
        { data: transformToSaveCuisineTypesArgs(data) },
        dispatch,
        SAVE_CUISINE_TYPES,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useSaveCuisineTypesMutation
